/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Component } from 'svelte'
import type { Object3D } from 'three'

type PrinterOption = {
  type: 'select'
  options: string[]
  default?: string
}

type OptionConstraintZone = {
  offsetX_MM: number
  offsetY_MM: number
  offsetZ_MM: number
  width_MM: number
  depth_MM: number
  height_MM: number
}

type OptionConstraints = Record<string, OptionConstraintZone[]>

abstract class BasePrinterDriver {
  static readonly addIcon: Component
  static readonly defaultGrid: FloorGridType
  static readonly defaultLayerHeightMm: number
  static readonly gcodeExtension: string
  static readonly hasCartesianGrid: boolean
  static readonly hasFullPrintableZone: boolean
  static readonly hasGhostPlacement: boolean
  static readonly hasHalfPrintableZone: boolean
  static readonly hasPolarGrid: boolean
  static readonly icon: Component
  static readonly model: PrinterModel
  static readonly name: string
  static readonly printerOptions: Record<string, PrinterOption>

  static get optionConstraints(): Record<string, OptionConstraints> { return {} }

  static getPolarZone(gridColor: string): Promise<Object3D> {
    throw new Error(`Method getPolarZone not implemented in ${this.name}`)
  };

  static getCartesianZone(gridColor: string): Promise<Object3D> {
    throw new Error(`Method getCartesianZone not implemented in ${this.name}`)
  };

  static getPrintableZone(type: PrintableZoneType, color: string): Promise<Object3D> {
    throw new Error(`Method getPrintableZone not implemented in ${this.name}`)
  };

  static getOptionConstraintZones(options: Record<string, string>): OptionConstraintZone[] {
    const zones: OptionConstraintZone[] = []
    for (const [optionKey, optionValue] of Object.entries(options)) {
      const constraintsForOption = this.optionConstraints?.[optionKey]
      if (constraintsForOption?.[optionValue]) {
        zones.push(...constraintsForOption[optionValue])
      }
    }
    return zones
  };

  static getDefaultOptions(): Record<string, string> {
    const defaults: Record<string, string> = {}
    for (const [key, option] of Object.entries(this.printerOptions ?? {})) {
      defaults[key] = option.default ?? option.options[0]
    }
    return defaults
  };

  static getDefaultUserData(): Record<string, string | number | boolean> {
    throw new Error(`Method getDefaultUserData not implemented in ${this.name}`)
  };

  static getMesh(colorOffset: number, forcedColor?: string): Promise<Object3D | null> {
    throw new Error(`Method getMesh not implemented in ${this.name}`)
  };
}

export type { PrinterOption, OptionConstraintZone, OptionConstraints }
export default BasePrinterDriver
